document.addEventListener('DOMContentLoaded', () => {
  const dateField = document.querySelector('.js-date');
  const timeField = document.querySelector('.js-time');

  // Wenn kein passendes Feld auf der Seite vorhanden ist → Script abbrechen
  if (!dateField || !timeField) return;

  const MORNING_START = 8 * 60 + 30;    // 8:30
  const MORNING_END   = 12 * 60 + 30;   // 12:30
  const AFTERNOON_START = 13 * 60 + 30; // 13:30
  const AFTERNOON_END   = 17 * 60;      // 17:00

  function validateTime() {
    const dateValue = dateField.value;
    const timeValue = timeField.value;

    // wenn eins von beiden leer ist → keine Fehlermeldung
    if (!dateValue || !timeValue) {
      timeField.setCustomValidity('');
      return;
    }

    const selectedDate = new Date(dateValue);
    const [hours, minutes] = timeValue.split(':').map(Number);
    const totalMinutes = hours * 60 + minutes;
    const weekday = selectedDate.getDay();

    // Samstag (6) und Sonntag (0) blockieren
    if (weekday === 0 || weekday === 6) {
      timeField.setCustomValidity('Bitte wählen Sie einen Termin an einem Werktag (Mo–Fr).');
      timeField.reportValidity();
      return;
    }

    const isFriday = weekday === 5;
    const validMorning = totalMinutes >= MORNING_START && totalMinutes <= MORNING_END;
    const validAfternoon = totalMinutes >= AFTERNOON_START && totalMinutes <= AFTERNOON_END;

    const isValid = validMorning || (!isFriday && validAfternoon);

    if (!isValid) {
      timeField.setCustomValidity(
        isFriday
          ? 'Freitags sind Termine nur zwischen 8:30 und 12:30 Uhr möglich.'
          : 'Bitte wählen Sie eine Uhrzeit innerhalb unserer Geschäftszeiten (8:30–12:30 Uhr oder 13:30–17:00 Uhr).'
      );
    } else {
      timeField.setCustomValidity('');
    }

    timeField.reportValidity();
  }

  timeField.addEventListener('input', validateTime);
  dateField.addEventListener('input', validateTime);
});